import React from "react";

const CustomSwitch = ({
    checked,
    onChange,
    label,
    size = "default",
    disabled = false,
}) => {
    const handleChange = () => {
        if (!disabled && onChange) {
            onChange({ target: { checked: !checked } });
        }
    };

    const switchClasses = [
        "segment-switch",
        `segment-switch--${size}`,
        disabled ? "segment-switch--disabled" : "",
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <div className="segment-switch-wrapper">
            {label && <span className="segment-switch__label">{label}</span>}
            <div className={switchClasses}>
                <button
                    type="button"
                    className={`segment-switch__option ${
                        !checked ? "segment-switch__option--active" : ""
                    }`}
                    onClick={() => handleChange()}
                    disabled={disabled}
                >
                    Off
                </button>
                <button
                    type="button"
                    className={`segment-switch__option ${
                        checked ? "segment-switch__option--active" : ""
                    }`}
                    onClick={() => handleChange()}
                    disabled={disabled}
                >
                    On
                </button>
            </div>
        </div>
    );
};

export default CustomSwitch;
